import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import { selectEnvironmentFile, CustomTranslateHttpLoader, TranslationService } from 'gast-common-ng';
import { environment } from '../environments/environment';
registerLocaleData(localeDe);
// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient) {
    var urls = [
        './common-assets/i18n/',
        './portal-assets/i18n/',
        './assets/i18n/'
    ];
    return new CustomTranslateHttpLoader(httpClient, urls, '.json');
}
export function TranslationServiceFactory(translationService) {
    return translationService;
}
var ɵ0 = { callback: selectEnvironmentFile, value: environment.envName };
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
